import React from 'react'
import Header from '../components/Header/Header'
import Homepage from '../components/Homepage/Homepage'
import Contactpage from '../components/Contactpage/Contactpage'
import Projectlist from '../components/Projectlist/Projectlist'
import Aboutpage from '../components/Aboutpage/Aboutpage'

function Home() {
  return (
    <div>
      <Header />
      <Homepage />
    </div>
  )
}

export default Home